import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, timeout: 30000 });

const RETRY_DELAYS = [500, 1500, 3000];
const RETRY_STATUSES = new Set([502, 503, 504, 520, 521, 522, 523, 524]);

function waitForRetry(delay, signal) {
  return new Promise((resolve, reject) => {
    const abort = () => {
      clearTimeout(timer);
      reject(new axios.CanceledError("Request cancelled"));
    };
    const timer = setTimeout(() => {
      signal?.removeEventListener("abort", abort);
      resolve();
    }, delay);
    if (signal?.aborted) abort();
    else signal?.addEventListener("abort", abort, { once: true });
  });
}

api.interceptors.response.use((response) => response, async (error) => {
  const config = error.config;
  const attempt = config?._readRetryCount || 0;
  const networkFailure = !error.response && (Boolean(error.request)
    || ["ERR_NETWORK", "ECONNABORTED", "ETIMEDOUT"].includes(error.code));
  // Deliberately GET-only: never replay orders, payments, or any other mutation.
  if (!config || config.method?.toLowerCase() !== "get" || axios.isCancel(error)
      || config.signal?.aborted || attempt >= RETRY_DELAYS.length
      || !(networkFailure || RETRY_STATUSES.has(error.response?.status))) {
    return Promise.reject(error);
  }
  config._readRetryCount = attempt + 1;
  await waitForRetry(RETRY_DELAYS[attempt], config.signal);
  return api.request(config);
});

export default api;
